// extracted by mini-css-extract-plugin
export default {"languages":"Language_languages__X1E5n","proffessionalTag":"Language_proffessionalTag__Hp27s"};